import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1),
  },
});

const CircledIconButton = ({
  children,
  onClick,
  ref,
  backgroundColor,
  title,
  className,
  classes,
  test,
}) => (
  <IconButton
    ref={ref}
    className={classNames(className, classes.root)}
    onClick={onClick}
    size={'small'}
    style={{ backgroundColor }}
    title={title}
    test={test}
  >
    {children}
  </IconButton>
);

CircledIconButton.defaultProps = {
  onClick: () => {},
  backgroundColor: null,
  ref: undefined,
  className: null,
  title: null,
  test: 'circled-icon-button',
};

CircledIconButton.propTypes = {
  children: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  ref: PropTypes.object,
  backgroundColor: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  test: PropTypes.string,
};

export default withStyles(styles)(CircledIconButton);
